import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import useGet from "../../hooks/read/useGet";
import toast from "react-hot-toast";
import {
  checkIfNotEmpty,
  convertUnixToDateTime,
  convertUnixToTime,
} from "../../utility";
import WFHModal from "./WFHModal";
import Pagination from "../../components/pagination";
import RoundedContainer from "../../components/containers/RoundedContainer";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableRow,
} from "../../components/table/Table";

const MarkWFHAttendance = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to open the modal
  const openModal = () => {
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { list: punchList, setGetListParams: setPunchListParams } = useGet({
    url: "fetch_users_wfh_data",
    onSuccess: () => {},
    initialData: {
      page_no: 0,
    },
    onError: () => {
      toast.error(
        "There Was An Error While Fetching The Data Please Try Again Later"
      );
    },
  });

  const pagination = punchList?.data;

  const handlePageClick = (val) => {
    setPunchListParams({ page_no: val.selected });
  };

  useEffect(() => {
    // Set interval to trigger the modal every 40 minutes (40 * 60 * 1000 milliseconds)
    const modalInterval = setInterval(() => {
      setIsModalOpen(true);
    }, 40 * 60 * 1000); // 40 minutes

    // Clear the interval when the component unmounts
    return () => clearInterval(modalInterval);
  }, []);

  return (
    <div className="px-5">
      <div className=" mb-4 flex items-center justify-between">
        <h1 className=" text-xl font-semibold">
          Remote work punch ins for : <Moment date={new Date()} format="LL" />{" "}
        </h1>
        <p className="font-semibold underline-offset-2 underline text-primary font-2xl">
          Required Punch Count :- {punchList?.data?.required_puch_count}
        </p>
      </div>
      <div>
        <div class="text-end flex space-x-3 justify-end text-dark font-medium text-sm lg:text-base lg:py-2 my-4 pb-4">
          <Link 
            to="/punchout"
            class="bg-[color:var(--color1)] text-white px-4 py-2 rounded-md"
          >
            Punch Out
          </Link>
          <Link
            to="/wfh/mark"
            class="bg-[color:var(--color1)] text-white px-4 py-2 rounded-md ml-2"
          >
            Mark Remote Work Attendance
          </Link>
        </div>
      </div>
      <RoundedContainer className="my-6">
        {punchList?.data?.punch_data?.length <= 0 ? (
          <div className="py-8 text-center font-semibold text-gray-500">
            No Punches Added Yet
          </div>
        ) : (
          <div className="max-w-full overflow-x-auto">
            <Table className="table-auto w-full">
              <TableHead>
                <TableHeaderCell className="w-[10%] text-center">
                  Sr.No
                </TableHeaderCell>
                <TableHeaderCell className="w-[30%] text-center">
                  Punch Date - Time
                </TableHeaderCell>
                <TableHeaderCell className="w-[30%] text-center">
                  Screen Capture
                </TableHeaderCell>
                <TableHeaderCell className="w-[30%] text-center">
                  Photo
                </TableHeaderCell>
              </TableHead>
              <TableBody>
                {punchList?.data?.punch_data?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell className="text-center text-dark font-medium text-sm">
                      {index + 1}
                    </TableCell>
                    <TableCell className="text-center text-dark font-medium text-sm">
                      <span className="text-xs bg-gray-200 px-2 py-1 rounded-md">
                        {convertUnixToDateTime(item.punch_time)}
                      </span>
                    </TableCell>
                    <TableCell className="text-center text-dark font-medium text-sm">
                      {checkIfNotEmpty(item?.full_screen_image_url) ? (
                        <a
                          href={item?.full_screen_image_url}
                          target="_blank"
                          className="text-primary hover:text-blue-700 underline"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                    <TableCell className="text-center text-dark font-medium text-sm">
                      {checkIfNotEmpty(item?.image_url) ? (
                        <a
                          href={item?.image_url}
                          target="_blank"
                          className="text-primary hover:text-blue-700 underline"
                          rel="noopener noreferrer"
                        >
                          View
                        </a>
                      ) : (
                        "-"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </RoundedContainer>

      {pagination?.total_count > pagination?.per_page && (
        <RoundedContainer className="my-4">
          <Pagination
            lengthofItems={pagination?.total_count}
            limit={pagination?.per_page}
            currentPage={pagination?.page_no}
            onPageChange={handlePageClick}
          />
        </RoundedContainer>
      )}
    </div>
  );
};

export default MarkWFHAttendance;
